// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resource-text-body{max-height:300px;overflow-y:scroll}.resource-images{display:flex;flex-direction:row;overflow-x:auto}.resource-images .image-box{margin:0 12px;min-width:25%;width:25%}.resource-images>label.checkbox{position:relative}.image-box input.checkbox{bottom:6px;position:absolute;right:6px}.resource-images .image-box:first-child{margin-left:0}.resource-images .image-box:last-child{margin-right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
